import { observer } from 'mobx-react-lite';
import { RouterProvider } from 'react-router-dom';

import { AppConfigProvider } from './app-config.provider';
import { useInstance } from './libs/use-instance';
import { AuthRequiredWidget } from './railways/domains/auth/features/auth-required-widget';
import { CheckAuth } from './railways/domains/auth/features/check-auth';
import {
  UserProfileProvider,
  UserProfileStore,
} from './railways/domains/profile/features/user-profile-data';
import { SignInModal } from './railways/domains/sign-in/features/sign-in-modal';
import { LoginPage } from './railways/domains/sign-in/pages';
import { router } from './router';

const App = observer(() => {
  const userProfileStore = useInstance(() => new UserProfileStore());

  return (
    <AppConfigProvider>
      <UserProfileProvider value={userProfileStore}>
        <CheckAuth login={<LoginPage />}>
          <RouterProvider router={router} />

          <AuthRequiredWidget>
            <SignInModal />
          </AuthRequiredWidget>
        </CheckAuth>
      </UserProfileProvider>
    </AppConfigProvider>
  );
});

export default App;
